import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text1 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {propertyLegalDefinition} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(propertyLegalDefinition) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>הגדרה משפטית של הנכס: </span>
          {getBreakLinesTextShumaType3(propertyLegalDefinition)}
        </div>
      )}
    </div>
  );
});

export default Section8Text1;
